import React from 'react';
import {HStack, VStack} from "native-base";
import {t} from "i18next";
import FormInput from "../../../../common/FormInput";
import CustomCheckbox from "../../../../common/CustomCheckbox";
import {Colors} from "../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../styles/GlobalStyles";
import AppText from "../../../../common/AppText";

const TextEditorTableInit = (props) => {
    const { values, setFieldValue, errors, touched } = props;

    return (
        <VStack space={'0.2rem'}>
            <HStack space={'0.8rem'}>
                <FormInput
                    label={t('rows')}
                    placeholder={t('rows-placeholder')}
                    onChangeCallback={(val) => setFieldValue('rows', val)}
                    value={values.rows}
                    width={'49%'}
                    numericOnly={true}
                    required={true}
                    containerProps={{mb: '0'}}
                />
                <FormInput
                    label={t('columns')}
                    placeholder={t('columns-placeholder')}
                    onChangeCallback={(val) => setFieldValue('columns', val)}
                    value={values.columns}
                    width={'49%'}
                    numericOnly={true}
                    required={true}
                    containerProps={{mb: '0'}}
                />
            </HStack>
            <AppText color={Colors.error} fontSize={GlobalStyleAttributes.fonts.infoText} width='max-content' mediumFont>
                {touched.columns && errors.columns ? errors.columns : null}
                {touched.rows && errors.rows ? errors.rows : null}
            </AppText>
            <CustomCheckbox isChecked={values.headerRow} onChange={(val) => setFieldValue('headerRow', val)} text={t('set-header-row')} />
            <CustomCheckbox isChecked={values.headerColumn} onChange={(val) => setFieldValue('headerColumn', val)} text={t('set-header-column')} />
        </VStack>
    );
};

export default TextEditorTableInit;